import { combineReducers } from '@reduxjs/toolkit';
import { reducer as globalReducer, reducerKey as globalReducerKey, } from './globalReducer';
import { reducer as creditPortalReducer } from './reducer';
const reducerKey = 'root';
const reducer = combineReducers({
    [globalReducerKey]: globalReducer,
    creditPortal: creditPortalReducer,
    //   [legalReducerKey]: legallReducer,
});
export { reducer, reducerKey };
